import { render } from "./CallHistory.vue?vue&type=template&id=bedc1206"
import script from "./CallHistory.vue?vue&type=script&lang=js"
export * from "./CallHistory.vue?vue&type=script&lang=js"

import "./CallHistory.vue?vue&type=style&index=0&id=bedc1206&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__